import { useQuery } from '@tanstack/react-query';

import {
  getKpiForecasts,
  KpiForecastsResponse,
} from '@/features/forecasts/api/get-kpi-forecasts';

export const getKpiForecastsQueryKey = (
  kpiId?: number,
  projectId?: number,
  kpiVariation?: 'derivative' | 'standard',
) => ['kpiForecasts', kpiId, projectId, kpiVariation];

export function useKpiForecasts(
  kpiId?: number,
  projectId?: number,
  kpiVariation: 'derivative' | 'standard' = 'standard',
) {
  return useQuery<KpiForecastsResponse>({
    queryKey: getKpiForecastsQueryKey(kpiId, projectId, kpiVariation),
    queryFn: () => getKpiForecasts(kpiId!, projectId!, kpiVariation),
    enabled: !!kpiId && !!projectId,
    staleTime: 1000 * 60 * 30,
    retry: 1,
  });
}
